import React, { useState } from "react";
import { Row, Col, Card, Tag, Steps, List, Avatar, Button, Badge, Select, Tabs, theme } from "antd";
import { UserOutlined } from "@ant-design/icons";
import "./DealDetails.css";
import { RiLock2Line } from "react-icons/ri";
import Activities from "./Activities";
import Files from "./Files";

import { useTranslation } from "react-i18next";
const { Step } = Steps;

const DealDetails = () => {
  const { t } = useTranslation("dashboard");
  const { token } = theme.useToken();
  const [dealStatus, setDealStatus] = useState("Won");
  const statusColor = dealStatus === "Lost" ? token.colorError : token.colorSuccess;
  const items = [
    {
      key: "1",
      label: t("Activities"),
      children: <Activities />
    },
    {
      key: "2",
      label: t("Files"),
      children: <Files />
    }
  ];

  return (
    <div className="DealDetails">
      {/* Page Header */}
      <Card className="page-header deal-details__header">
        <div className="deal-details__identity">
          <Avatar
            className="deal-details__avatar"
            size={{ xs: 72, sm: 72, md: 96, lg: 130, xl: 130, xxl: 130 }}
            icon={<UserOutlined />}
          />
          <div className="deal-details__identity-text">
            <h2>{t("Tremblay and Rath")}</h2>
            <p>{t("Google Inc")}</p>
            <p>22, Ave Street, Newyork, USA</p>
          </div>
        </div>
        <div className="deal-details__header-actions">
          <Button icon={<RiLock2Line />}>{t("Private")}</Button>
          <Select
            className="deal-details__status"
            style={{
              "--deal-status-color": statusColor,
              "--deal-status-text": token.colorTextLightSolid
            }}
            variant="borderless"
            value={dealStatus}
            onChange={setDealStatus}
            popupMatchSelectWidth={false}
            options={[
              {
                value: "Won",
                label: t("Won")
              },
              {
                value: "Lost",
                label: t("Lost")
              }
            ]}
          />
        </div>
      </Card>
      <Row gutter={[16, 16]} className="deal-details__body">
        {/* Left Section */}
        <Col xs={24} lg={8}>
          <Card className="dealInfo">
            <h2>{t("Deal Information")}</h2>
            <dl className="deal-details__facts">
              <div>
                <dt>{t("Date Created:")}</dt>
                <dd>10 Jan 2024, 10:00 am</dd>
              </div>
              <div>
                <dt>{t("Probability:")}</dt>
                <dd>{t("Win 80%")}</dd>
              </div>
              <div>
                <dt>{t("Deal Value:")}</dt>
                <dd>$25,11,145</dd>
              </div>
              <div>
                <dt>{t("Due Date:")}</dt>
                <dd>20 Jan 2024, 10:00 am</dd>
              </div>
              <div>
                <dt>{t("Follow Up:")}</dt>
                <dd>20 Jan 2024</dd>
              </div>
              <div>
                <dt>{t("Source:")}</dt>
                <dd>{t("Google")}</dd>
              </div>
            </dl>

            <div>
              <h4>{t("Deal Owner")}</h4>
              <List
                itemLayout="horizontal"
                dataSource={["Vaughan", "Jessica"]}
                renderItem={item => (
                  <List.Item>
                    <List.Item.Meta avatar={<Avatar icon={<UserOutlined />} />} title={item} />
                  </List.Item>
                )}
              />
            </div>

            <div>
              <h4>{t("Tags")}</h4>
              <div className="deal-details__tags">
                <Tag color="green">{t("Collab")}</Tag>
                <Tag color="orange">{t("Rated")}</Tag>
              </div>
            </div>

            <div>
              <h4>{t("Priority")}</h4>
              <Badge status="error" text={t("High")} />
            </div>

            <div>
              <h4>{t("Projects")}</h4>
              <div className="deal-details__tags">
                <Tag>{t("Devops Design")}</Tag>
                <Tag>{t("Margate Design")}</Tag>
              </div>
            </div>

            <div>
              <h4>{t("Contacts")}</h4>
              <List
                itemLayout="horizontal"
                dataSource={["Vaughan", "Jessica"]}
                renderItem={item => (
                  <List.Item>
                    <List.Item.Meta avatar={<Avatar icon={<UserOutlined />} />} title={item} />
                  </List.Item>
                )}
              />
            </div>
          </Card>
        </Col>

        {/* Right Section */}
        <Col xs={24} lg={16}>
          <Card>
            <div className="deal-details__steps">
              <Steps current={2} size="small">
                <Step title={t("Qualify To Buy")} />
                <Step title={t("Contact Made")} />
                <Step title={t("Presentation")} />
                <Step title={t("Proposal Made")} />
              </Steps>
            </div>
            <div className="mt-4">
              <Tabs defaultActiveKey="1" items={items} />
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default DealDetails;
